import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, formatLeft, STATUS_LABEL } from "../lib/api";
import { useNow } from "../lib/useNow";

const STATUS_CLS = {
  active: "bg-[#E0533C]/15 text-[#F08A78]",
  reserved: "bg-amber-500/15 text-amber-300",
  completed: "bg-emerald-500/15 text-emerald-300",
  cancelled: "bg-stone-700/40 text-stone-400",
};

const Row = ({ s, now, onAct }) => {
  const live = ["active", "reserved"].includes(s.status) && new Date(s.leave_at).getTime() > now - 600000;
  return (
    <li data-testid={`activity-item-${s.id}`} className="rounded-2xl bg-stone-900 border border-stone-800 p-4 flex flex-wrap items-center gap-3">
      <div className="flex-1 min-w-[180px]">
        <p className="font-semibold">{s.address}</p>
        <p className="text-xs text-stone-500 mt-1">
          {s.is_mine ? "Hai lasciato il posto" : "Hai prenotato"} · {new Date(s.created_at).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" })}
          {s.is_mine && s.status === "reserved" && " · prenotato da un utente anonimo"}
        </p>
      </div>
      {live && <span className="font-mono-x text-sm">{formatLeft(s.leave_at, now)}</span>}
      <span className={`text-xs font-semibold rounded-full px-2.5 py-1 ${STATUS_CLS[s.status]}`}>{live || !["active", "reserved"].includes(s.status) ? STATUS_LABEL[s.status] : "Scaduto"}</span>
      {live && s.is_mine && <button data-testid={`activity-cancel-${s.id}`} onClick={() => onAct(s.id, "cancel")} className="text-sm text-stone-300 underline hover:text-white">Annulla</button>}
      {live && s.status === "reserved" && <button data-testid={`activity-complete-${s.id}`} onClick={() => onAct(s.id, "complete")} className="text-sm text-emerald-300 underline hover:text-emerald-200">Scambio completato</button>}
    </li>
  );
};

export default function ActivityPage() {
  const [items, setItems] = useState(null);
  const now = useNow();
  const load = useCallback(() => api.get("/me/activity").then((r) => setItems(r.data)), []);
  useEffect(() => { load(); }, [load]);

  const onAct = async (id, path) => {
    try {
      await api.post(`/spots/${id}/${path}`);
      toast.success("Aggiornato");
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8 rise">
      <h2 className="font-display text-3xl sm:text-4xl font-extrabold">Le mie attività</h2>
      <p className="text-sm text-stone-400 mt-1">Le tue segnalazioni e prenotazioni. Gli altri utenti restano anonimi.</p>
      <ul data-testid="activity-list" className="mt-6 space-y-3">
        {items?.length === 0 && <li className="text-stone-500 text-sm">Ancora nessuna attività.</li>}
        {items?.map((s) => <Row key={s.id} s={s} now={now} onAct={onAct} />)}
      </ul>
    </div>
  );
}
